import { useState } from 'react';
import { DashboardFormWrapper } from '../dashboard';
import { GateOutsPage } from './GateOutsComponents';
import { GateOutsAddHeader, GateOutsAddForm } from './GateOutsAddComponents';
import * as GateOutFilter from './GateOutsAddByFilterComponents';
import { RoleGuard } from '../../routes';
import { ContainerListModal } from '../../design-system';

export const GateOutsAdd = () => {
  const [createMode, setCreateMode] = useState('normal');

  return (
    <RoleGuard roles={['YARD_COMPANY_VIEWER']} negative>
      <RoleGuard roles={['TRADER']} isMobile negative>
        {createMode === 'normal' && (
          <GateOutsPage>
            <GateOutsAddHeader />
            <DashboardFormWrapper flow={'row'}>
              <GateOutsAddForm createMode={createMode} setCreateMode={setCreateMode} />
              <GateOutsAddHeader showOnlySubmit />
            </DashboardFormWrapper>
          </GateOutsPage>
        )}
        {createMode === 'filter' && (
          <GateOutsPage>
            <GateOutFilter.GateOutsAddHeader />
            <DashboardFormWrapper flow={'row'}>
              <GateOutFilter.GateOutsAddForm
                createMode={createMode}
                setCreateMode={setCreateMode}
              />
              <GateOutFilter.GateOutsAddHeader showOnlySubmit />
            </DashboardFormWrapper>
          </GateOutsPage>
        )}
        <ContainerListModal />
      </RoleGuard>
    </RoleGuard>
  );
};
